import React from "react";
import { Link } from "react-router-dom";
import "./../../css/emptyCart.css";

export default function EmptyCart() {
  return (
    <div className="empty-cart-wrapper">
      <div className="cart-animation">🛒</div>

      <h2>Your cart is feeling lonely</h2>
      <p>
        Looks like you haven’t added anything yet. Explore BharatDhara’s pure &
        authentic products 🌿
      </p>

      <Link to="/shop" className="shop-btn">
        Start Shopping
      </Link>
    </div>
  );
}
